/**
 * It converts %anystring% to \{\{anystring\}\}.
 */
export const convertToI18nTemplateString = (string: string): string => {
  // We were using %anystring% that is not compatible with i18next so this function converts it to \{\{ anystring \}\}.
  return string.replaceAll(/%(\w+)%/g, (notUsed, key: string) => `{{${key}}}`)
}
